import { ApiResponse } from "../interfaces/trip.interfaces";
import {
  GetMessagesResponse,
  GetSessionResponse,
  SendMessageResponse,
  StartSessionRequest,
  StartSessionResponse,
} from "../interfaces/chat.interfaces";
import { apiClient } from "../utils/apiClient";

export async function startChatSession(
  request: StartSessionRequest = { channel: "web" },
): Promise<ApiResponse<StartSessionResponse>> {
  return apiClient.post<ApiResponse<StartSessionResponse>>(
    "/StartChatSessionHTTP",
    "/StartChatSessionHTTP",
    request,
  );
}

export async function sendChatMessage(
  sessionId: string,
  content: string,
): Promise<ApiResponse<SendMessageResponse>> {
  return apiClient.post<ApiResponse<SendMessageResponse>>(
    "/SendChatMessageHTTP",
    "/SendChatMessageHTTP",
    { sessionId, content },
  );
}

export async function getChatMessages(
  sessionId: string,
): Promise<ApiResponse<GetMessagesResponse>> {
  return apiClient.get<GetMessagesResponse>(
    "/GetChatMessagesHTTP",
    "/GetChatMessagesHTTP",
    { sessionId },
  );
}

export async function getChatSession(
  sessionId: string,
): Promise<ApiResponse<GetSessionResponse>> {
  return apiClient.get<GetSessionResponse>(
    "/GetChatSessionHTTP",
    "/GetChatSessionHTTP",
    { sessionId },
  );
}
